import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

export const apiUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api`;

type QueryParam = number | string;

const StrapiMetaSchema = z.object({
  pagination: z
    .object({
      page: z.number(),
      pageSize: z.number(),
      pageCount: z.number(),
      total: z.number(),
      start: z.number(),
      limit: z.number(),
    })
    .partial(),
});

export const StripeSingleDataZodSchema = <T extends ZodTypeAny>(
  itemSchema: T
) =>
  z.object({
    data: itemSchema,
  });

export const StripeCollectionDataZodSchema = <T extends ZodTypeAny>(
  itemSchema: T
) =>
  z.object({
    data: z.array(itemSchema),
    meta: StrapiMetaSchema.optional(),
  });

export const apiRoutes = {
  candidatesBlogs: {
    _root: `${apiUrl}/candidate-blogs`,
    detail: (id: QueryParam) => `${apiUrl}/candidate-blogs/${id}`,
  },
  aiCompanies: {
    _root: `${apiUrl}/ai-companies`,
    detail: (id: QueryParam) => `${apiUrl}/ai-companies/${id}`,
  },
  pressRoom: {
    _root: `${apiUrl}/press-rooms`,
    detail: (id: QueryParam) => `${apiUrl}/press-rooms/${id}`,
  },
  conTechBlogs: {
    _root: `${apiUrl}/con-tech-blogs`,
    detail: (id: QueryParam) => `${apiUrl}/con-tech-blogs/${id}`,
  },
  tags: {
    _root: `${apiUrl}/tags`,
  },
  conTechTags: {
    _root: `${apiUrl}/con-tech-tags`,
  },
  privacyPolicy: {
    _root: `${apiUrl}/privacy-policy`,
  },
  termsOfService: {
    _root: `${apiUrl}/terms-of-service`,
  },
  cookiePolicy: {
    _root: `${apiUrl}/cookie-policy`,
  },
  responsibleDisclosure: {
    _root: `${apiUrl}/responsible-disclosure`,
  },
  smsTerms: {
    _root: `${apiUrl}/sms-terms`,
  },
  teamMembers: {
    _root: `${apiUrl}/team-members`,
  },
  industries: {
    _root: `${apiUrl}/industries`,
    detail: (id: QueryParam) => `${apiUrl}/industries/${id}`,
  },
  verticals: {
    _root: `${apiUrl}/verticals`,
    detail: (id: QueryParam) => `${apiUrl}/verticals/${id}`,
  },
};
